// @flow

const nextInputID = (() => {
  let count = 0;

  return () => `input-${count++}`;
})();

export default nextInputID;
